module.exports = __webpack_public_path__ + "img/red_050.2b9bac8b.png";